import { render, staticRenderFns } from "./CitizenshipReports.vue?vue&type=template&id=98c8e8f2&scoped=true"
import script from "./CitizenshipReports.vue?vue&type=script&lang=js"
export * from "./CitizenshipReports.vue?vue&type=script&lang=js"
import style0 from "./CitizenshipReports.vue?vue&type=style&index=0&id=98c8e8f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c8e8f2",
  null
  
)

export default component.exports